import TextField from 'apollo-react/components/TextField';
import React from 'react';

function TextFieldFilter({ accessor, filters, updateFilterValue }) {
  return (
    <TextField
      value={filters[accessor] ?? ''}
      name={accessor}
      onChange={updateFilterValue}
      fullWidth
      size="small"
      margin="none"
      InputProps={{
        inputProps: {
          'aria-label': { accessor },
        },
      }}
    />
  );
}

export default TextFieldFilter;
